import { FC } from 'react';
import { Brands, Headline } from '~/lib/data-contract';
import { Carousel } from '~/shared/components/Carousel';
import { weakKey } from '~/shared/utils/jsx';
import ChevronLeft from '~/icons/chevron-left.svg';
import ChevronRight from '~/icons/chevron.svg';
import { BrandsCategory } from '../BrandCard/BrandCategory';
import { Button } from '~/shared/components';
import { useGetCarouselOptions } from '~/templates/blocks/hooks/useGetCarouselOptions';
import styles from './BrandCarousel.module.scss';
import { SkipToNextBlock } from '~/shared/components/SkipToNextBlock.ts';

export type CarouselProps = {
    items: Brands[];
    priority?: boolean;
    headline?: Headline;
    textColor?: string;
    isSkipHidden?: boolean;
};

const BrandCarousel: FC<CarouselProps> = (props: CarouselProps) => {
    const { items, priority, isSkipHidden } = props;
    const { shouldShowButtons, carouselOptions, leftArrow, rightArrow } =
        useGetCarouselOptions(items);

    return (
        <div className={styles.container}>
            {!isSkipHidden && <SkipToNextBlock />}
            {shouldShowButtons && (
                <Button
                    tabIndex={-1}
                    className={styles.cardCarouselLeft}
                    variant="icon"
                    ref={leftArrow}
                    aria-label="Scroll til venstre"
                >
                    <ChevronLeft />
                </Button>
            )}
            <div className={styles.cardCarouselContainer}>
                <Carousel
                    options={carouselOptions}
                    nextRef={rightArrow}
                    prevRef={leftArrow}
                    items={items.map((item) => (
                        <BrandsCategory
                            noPadding={true}
                            priority={priority}
                            key={weakKey(item)}
                            item={item}
                        />
                    ))}
                />
            </div>
            {shouldShowButtons && (
                <Button
                    tabIndex={-1}
                    className={styles.cardCarouselRight}
                    variant="icon"
                    ref={rightArrow}
                    aria-label="Scroll til højre"
                >
                    <ChevronRight />
                </Button>
            )}
        </div>
    );
};

export default BrandCarousel;
